// Mock data for Garage 1225 Sàrl

export const garageInfo = {
  name: "Garage 1225 Sàrl",
  address: "Rue François-Jacquier 17",
  city: "1225 Chêne-Bourg",
  phone: "022 860 07 07",
  phoneLink: "+41228600707",
  email: "garage1225@bluewin.ch",
  logo: "https://customer-assets.emergentagent.com/job_diagnostic-garage/artifacts/sgos5wj5_image0.jpeg",
  hours: {
    "Lundi - Jeudi": "07:30 - 12:00 | 13:30 - 17:30",
    "Vendredi": "07:30 - 12:00 | 13:30 - 16:30",
    "Samedi - Dimanche": "Fermé"
  }
};

export const garageImages = {
  hero: "https://customer-assets.emergentagent.com/job_diagnostic-garage/artifacts/2zahptv4_image1.jpeg",
  workshop1: "https://customer-assets.emergentagent.com/job_diagnostic-garage/artifacts/2zahptv4_image1.jpeg",
  workshop2: "https://customer-assets.emergentagent.com/job_diagnostic-garage/artifacts/7lrwdeuj_image2.jpeg",
  bmwDetail: "https://customer-assets.emergentagent.com/job_diagnostic-garage/artifacts/iy045t71_image3.jpeg",
  bmwLift: "https://customer-assets.emergentagent.com/job_diagnostic-garage/artifacts/c1e0rfjt_image4.jpeg"
};

export const services = [
  {
    id: 1,
    icon: "Wrench",
    title: "Toute Mécanique",
    description: "Réparations mécaniques complètes pour tous types de véhicules",
    details: "Notre équipe qualifiée intervient sur tous les systèmes mécaniques de votre véhicule : moteur, transmission, suspension, freinage. Diagnostic précis et réparations professionnelles."
  },
  {
    id: 2,
    icon: "Gauge",
    title: "Réparation & Diagnostic",
    description: "Diagnostic électronique avancé et réparations ciblées",
    details: "Équipés d'outils de diagnostic modernes, nous identifions rapidement les problèmes et proposons des solutions adaptées à votre véhicule."
  },
  {
    id: 3,
    icon: "CircleDot",
    title: "Changement de Pneus",
    description: "Vente et montage de pneus de toutes marques",
    details: "Service complet de pneumatiques : conseil, vente, montage et équilibrage. Pneus été, hiver et toutes saisons disponibles."
  },
  {
    id: 4,
    icon: "Settings",
    title: "Entretien Constructeur",
    description: "Service et entretien selon normes constructeur",
    details: "Entretien périodique respectant les préconisations constructeur. Service complet incluant vidange, filtres, contrôles de sécurité."
  },
  {
    id: 5,
    icon: "ClipboardCheck",
    title: "Contrôle & Préparation Expertise",
    description: "Préparation complète pour visite technique",
    details: "Préparation minutieuse de votre véhicule pour l'expertise : contrôles techniques, présentation à la visite, lavage châssis et moteur sur pont élévateur."
  },
  {
    id: 6,
    icon: "Cog",
    title: "Distribution & Embrayage",
    description: "Remplacement courroie de distribution et embrayage",
    details: "Intervention experte sur les éléments de distribution et d'embrayage. Prévention des pannes et optimisation des performances."
  },
  {
    id: 7,
    icon: "Target",
    title: "Géométrie",
    description: "Réglage et contrôle de la géométrie",
    details: "Contrôle et réglage précis de la géométrie de votre véhicule pour optimiser la tenue de route et l'usure des pneus."
  },
  {
    id: 8,
    icon: "Lightbulb",
    title: "Réglage des Phares",
    description: "Réglage et contrôle de l'éclairage",
    details: "Contrôle et réglage des phares pour assurer une visibilité optimale et conforme aux normes de sécurité."
  },
  {
    id: 9,
    icon: "Wind",
    title: "Climatisation",
    description: "Entretien et recharge climatisation",
    details: "Service complet de climatisation : diagnostic, recharge, désinfection et entretien du système de climatisation."
  },
  {
    id: 10,
    icon: "Battery",
    title: "Batterie & Codage",
    description: "Remplacement et codage de batterie",
    details: "Remplacement de batterie avec codage électronique pour les véhicules modernes nécessitant une programmation spécifique."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carla Stephani",
    rating: 5,
    comment: "Un garage comme on aimerait en trouver partout. J'y ai confié plusieurs de mes voitures et j'ai toujours été accueillie avec bienveillance, écoute et beaucoup de professionnalisme. Le propriétaire est d'une aide précieuse, toujours disponible et arrangeant. Une vraie relation de confiance. Merci encore 🙏"
  },
  {
    id: 2,
    name: "Céleste Leal",
    rating: 5,
    comment: "J'ai fais toutes les réparations de ma voiture dans ce garage ces dernières années, et ils ont toujours été très efficaces, rapides et professionnels!! Je recommande."
  },
  {
    id: 3,
    name: "Stéph SLB",
    rating: 5,
    comment: "Des années que je fais l'entretien de ma voiture dans ce garage. C'est vraiment la perle rare. Honnêteté, transparence et compétence sont les mots qui correspondent le mieux au garage 1225."
  },
  {
    id: 4,
    name: "M C",
    rating: 5,
    comment: "Entièrement satisfait des travaux exécutés sur mon véhicule que se soit pour les délais ainsi que pour le tarif. Garage très sérieux. Je recommande vivement."
  }
];

export const aboutContent = {
  title: "À Propos de Garage 1225 Sàrl",
  description: "Votre partenaire de confiance pour l'entretien et la réparation automobile à Chêne-Bourg",
  paragraphs: [
    "Le Garage 1225 Sàrl est votre spécialiste automobile de confiance situé à Chêne-Bourg. Depuis mai 2015, nous nous engageons à fournir des services de qualité supérieure à tous nos clients.",
    "Notre équipe de mécaniciens qualifiés et passionnés met son expertise au service de votre véhicule. Que ce soit pour un entretien courant, une réparation complexe ou une préparation à l'expertise, nous traitons chaque véhicule avec le plus grand soin.",
    "Nous investissons continuellement dans les dernières technologies de diagnostic et les équipements modernes pour garantir des interventions précises et efficaces sur tous types de véhicules."
  ],
  values: [
    {
      title: "Expertise",
      description: "Mécaniciens qualifiés et formation continue"
    },
    {
      title: "Transparence",
      description: "Devis clairs et conseils honnêtes"
    },
    {
      title: "Qualité",
      description: "Pièces de qualité et travail soigné"
    },
    {
      title: "Service personnalisé",
      description: "Écoute client et proximité"
    }
  ]
};
